const BackendLink = "https://api.fdenergies.com";
// const BackendLink = "http://127.0.0.1:8000" //localhost for development;

export default BackendLink